import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalCommunicationService {
  private triggerCargarDatos = new Subject<void>();

  triggerCargarDatos$ = this.triggerCargarDatos.asObservable();

  emitirCargarDatos() {
    this.triggerCargarDatos.next();
  }
}
